.stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  gap: var(--space-4);
  margin-bottom: var(--space-6);
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
  gap: var(--space-5);
  align-items: start;
}

.chartBody {
  padding: var(--space-4) var(--space-4) var(--space-3);
}

.legend {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: 0 var(--space-4) var(--space-3);
  font-size: var(--text-xs);
  color: var(--text-tertiary);
}

.swatch {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  background: var(--viz-1);
}

.note {
  font-size: var(--text-xs);
  color: var(--text-tertiary);
  line-height: var(--leading-relaxed);
  padding: 0 var(--space-4) var(--space-4);
}
